module.exports = __webpack_public_path__ + "../static/img/ping-icon.acd1674d.png";